import {axiosInstance} from "./base";

export const listQuestions = () => axiosInstance.get('/api/v1/user/factor/questions');

export const updateQuestion = (factorId, question, answer) => axiosInstance.post(`/api/v1/user/factor/enroll/question/${factorId}`, {
    question,
    answer
});

export const enrollQuestion = (question, answer) => axiosInstance.post('/api/v1/user/factor/enroll', {
    "factorType":"question",
    "provider":"OKTA",
    question,
    answer
});

export const enrollCall = (phoneNumber, phoneExtension) => axiosInstance.post('/api/v1/user/factor/enroll/phone', {
    "factorType":"call",
    "provider":"OKTA",
    phoneNumber,
    phoneExtension
});

export const enrollSms = (phoneNumber)=> axiosInstance.post('/api/v1/user/factor/enroll/phone', {
    "factorType":"sms",
    "provider":"OKTA",
    phoneNumber
});

export const enrollEmail = (email) => axiosInstance.post('/api/v1/user/factor/enroll/email', {
    factorType: 'email',
    provider: 'OKTA',
    email,
});


export const enrollFactor = (factorType, provider, others) => axiosInstance.post('/api/v1/user/factor/enroll', {
    factorType,
    provider,
    ...others,
});

export const activateTotp = (factorId, passCode) => axiosInstance.post(`/api/v1/user/factor/${factorId}/activate`, {
    passCode
});

//TODO
export const pollActivatePush = (factorId) => axiosInstance.post(`/api/v1/user/factor/${factorId}/activate/poll`, {});

export const activateWebAuthn = (factorId, attestation, clientData) => axiosInstance.post(`/api/v1/user/factor/${factorId}/activate`, {
    attestation,
    clientData
});

export const issueFactor = (factorId) => axiosInstance.post(`/api/v1/user/factor/${factorId}/issue`, {});

export const verifyQuestion = (factorId, answer) => axiosInstance.post(`/api/v1/user/factor/${factorId}/verify`, {
    answer
});

export const verifyTotp = (factorId, passCode) => axiosInstance.post(`/api/v1/user/factor/${factorId}/verify`, {
    passCode,
});
//Todo
export const pollVerifyPush = (factorId, passCode) => axiosInstance.post(`/api/v1/user/factor/${factorId}/verify/poll`, {});

export const verifyWebAuth = (factorId, authenticatorData, clientData, signatureData) => axiosInstance.post(`/api/v1/user/factor/${factorId}/verify`, {
    authenticatorData,
    clientData,
    signatureData
});
export const resetFactor = (factorId) => axiosInstance.delete(`/api/v1/user/factor/${factorId}`);


export const getTotpSecret = () => axiosInstance.get(`/api/v1/user/factor/totp/secret`);
export const enrollTotp = (issuer, secret, passCode) => axiosInstance.post(`/api/v1/user/factor/enroll/totp`, {
    issuer,
    secret,
    passCode,
    timestamp: Date.now(),
});
